import React from "react";
import Phero from "../../components/phero";
import Head from "../../components/head";

const Post = () => {
  return (
    <>
      <Head
        title="Communication skill criteria information gathering"
        dis="Majority of OET candidates believe information gathering means
            asking questions. However, this notion is only partially correct.
            Always try to compare your interaction"
      />
      <div className="post">
        <Phero herotitle="Communication skill criteria information gathering" />
        <div className="post-content container">
          <p>
            Majority of OET candidates believe information gathering means
            asking questions. However, this notion is only partially correct.
            Always try to compare your interaction with patients as an
            interaction of 2 people who visually don’t know each other. Would
            any normal human being be comfortable to discuss their personal
            life, habit confidential issues or sensitive topic with someone whom
            they meet for the first time? Certainly not!
          </p>

          <p>
            Therefore, the information gathering should be done in a way which
            helps you as a healthcare professional to build that initial sense
            of trust. Firstly, be an alternative listener use phrases such as
            ‘UM’, ‘I see’ to convey the message that you are listening to their
            narrative interestingly. This, in turn, will motivate the patient to
            open up.
          </p>
          <p>
            Questioning itself is a skill. Do not compare the questioning of OET
            Test with your actual consultation. In a real consultation, you may
            ask multiple questions to rule out other disease conditions, but in
            OET, you have always been provided with a diagnosis. So, limit your
            questions to the particular disease condition.
          </p>
          <p>
            For example, in real scenarios, if a patient presents with chest
            pain you may ask a number of questions to confirm if they are
            related to lungs, ribs, muscles, or heart. However, in the case of
            OET the role play card would mention that they have angina. So you
            limit your questions to the symptoms related to angina and the
            impact of this pain on the patient’s daily routine. It is important
            to note that if certain information is given, that does not mean you
            can’t ask questions related to those symptoms. You should plan a set
            of 8 -10 questions which would help you to get an overall idea about
            the patient’s condition.
          </p>
          <p>
            Questions should be framed as per the clinical communication skill
            framework. Always start with an open-ended question and then
            encourage patients to describe further details by slowly moving
            towards a targeted or closed question. Often, the patient may have
            underlying grief or guilty or they may have been an introvert
            person. In that case, you should be tactful in eliciting the
            information.
          </p>
          <p>For Example,</p>
          <p>
            <em>
              “Okay, I see that you are suffering from cough for 3 days, but as
              this is your first visit, I would like to ask more questions to
              get a detailed picture. May I?
              <br />
              <br />
              “I can see that your child has got a cut on his hand. Can you tell
              me how did it happen?” <br />
              <br />
              “I can see that you are very upset, can you tell me what exactly
              are you worried about?”
            </em>
          </p>
          <p>
            <strong>
              Generally, you should follow this sequence while questioning.
            </strong>
          </p>
          <p>
            1. Reason for presenting <br />
            <br /> <em>What brings you here today?</em>
          </p>
          <p>
            2. Duration <br />
            <br />{" "}
            <em>
              When did you first notice the rash? <br />
              <br />
              How long have you had this rash?
            </em>
          </p>
          <p>
            3. Location <br />
            <br />{" "}
            <em>
              Apart from your hands do you have rashes on any other body parts?
            </em>
          </p>
          <p>
            4. Characteristic <br />
            <br /> <em>Is the rash painful or itchy?</em>
          </p>
          <p>
            5. Cause / aggravating factor
            <br />
            <br /> <em>Do you know what may have caused this?</em> <br />
            (This question will help you to understand patient’s perspective
            about the situation and sometimes can give you a very important clue
            about their disease condition)
            <em>
              What makes it worse?
              <br />
              <br />
              What seems to bring on the rash?
            </em>
          </p>
          <p>
            6. Associated symptoms
            <br />
            <br /> <em>Apart from rash, do you have any fever or cough?</em>
          </p>
          <p>
            7. Impact on ADL / Work / Sleep
            <br />
            <br />{" "}
            <em>
              This question is optional. Based on which type of task you have.
              You can include/exclude this question.
              <br />
              <br />
              Does it affect your routine?
              <br />
              <br />
              Does it wake you up at night?
            </em>
          </p>
          <p>
            8. The treatment they may have received?
            <br />
            <br />{" "}
            <em>
              So what did you do for the rash? <br />
              <br />
              Did you seek any treatment?
              <br />
              <br />
              Have you taken anything to treat the rash?
            </em>
          </p>
        </div>
      </div>
    </>
  );
};

export default Post;
